module.exports = __webpack_public_path__ + "img/datosestancia.a7330fb0.png";